import { acceptHMRUpdate, defineStore } from 'pinia'

import { userpilotClient } from '~/services/UserpilotClient.ts'
import { type CaseSourceName, type CaseType, type Env, type OrganizationPolicy } from '~/types.ts'

export const useInitialState = defineStore('initialState', {
  state: () => ({
    adverse: {
      keys: [] as string[],
      labels: {} as Record<string, string>,
      minimum_threshold: 0,
    },
    companyAbbreviations: {} as Record<string, number>,
    defaultPolicies: {} as OrganizationPolicy,
    editableProducts: [] as string[],
    env: {
      app_name: (document.head.querySelector('meta[name="app-name"]') as HTMLMetaElement).content,
      app_env: '',
      browser: {
        name: '',
        version: '',
      },
      datachecker: {
        retention_seconds: 0,
        desktop_mode: false,
      },
      statuspage: {
        url: '',
      },
      version: '',
    } as Env,
    ignoredUpdateFields: [] as string[],
    newsCoverageMultiplier: 0,
    sessionId: 0,
    sourceFields: {} as Record<CaseSourceName, string[]>,
    sourceKeyFields: {} as Record<CaseSourceName, string[]>,
    sourceLabels: {} as Record<CaseSourceName, string>,
    sourcesPerType: {} as Record<CaseType, CaseSourceName[]>,
  }),

  actions: {
    async load() {
      const { data } = await window.initialStatePromise

      this.$state = data
      app.config.globalProperties.$env = window.$env = this.env
      if ($env.browser.name === '') {
        return
      }

      userpilotClient.run($env.userpilot)
      useContentsquareTracking().init()

      Object.assign(stores.policies.defaults, data.defaultPolicies)
      stores.source.$state = { fields: data.sourceFields, keyFields: data.sourceKeyFields, perType: data.sourcesPerType, labels: data.sourceLabels }
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useInitialState, import.meta.hot))
}
